<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT' || isExistRequestNo"
                >
                  <v-text-field
                    slot="activator"
                    v-model="issueDate"
                    label="Issue Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="issueDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="stockTransfer.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No."
                  v-model="stockTransfer.issueNo"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="stockTransfer.id && user.roleName == 'ADMIN'">
                <v-autocomplete
                  v-model="stockTransfer.status"
                  :items="adminStatusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :readonly="
                    status == 'FINISHED'
                      ? true
                      : status == 'CANCEL'
                      ? true
                      : false
                  "
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                sm6
                v-if="
                  stockTransfer.id &&
                  (user.roleName == 'WAREHOUSE_MANAGER' ||
                    user.roleName == 'WAREHOUSE_STAFF' ||
                    user.roleName == 'BRANCH_ADMIN')
                "
              >
                <v-autocomplete
                  v-model="stockTransfer.status"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :readonly="
                    status == 'FINISHED'
                      ? true
                      : status == 'CANCEL'
                      ? true
                      : false
                  "
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="serialNo"
                  label="Serial No."
                  v-model="stockTransfer.serialNo"
                  type="text"
                  :rules="rules.serialNoRules(255, 'Serial No')"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="stockTransfer.fromWarehouseName"
                  :items="activeWarehouseList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="From Warehouse"
                  item-text="name"
                  item-value="name"
                  menu-props="auto"
                  v-on:change="changeFromWarehouse()"
                  :readonly="
                    status != 'DRAFT' ||
                    user.role.roleName == 'WAREHOUSE_MANAGER' ||
                    user.role.roleName == 'WAREHOUSE_STAFF' ||
                    user.role.roleName == 'BRANCH_ADMIN' ||
                    isExistRequestNo
                  "
                  :rules="[
                    () =>
                      !!stockTransfer.fromWarehouseName ||
                      'From warehouse is required.',
                  ]"
                ></v-autocomplete>
                <h3
                  v-if="isError"
                  style="color: #ff5252; font: 12px Roboto, sans-serif"
                >
                  {{ error }}
                </h3>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="stockTransfer.fromBinId"
                  :items="fromBinList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="From Bin"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :readonly="status != 'DRAFT'"
                  :rules="[
                    () => !!stockTransfer.fromBinId || 'From Bin is required.',
                  ]"
                  @change="changeFromBin()"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12 v-if="!toBinFlag">
                <v-autocomplete
                  v-model="stockTransfer.toWarehouseName"
                  :items="activeWarehouseList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="To Warehouse"
                  item-text="name"
                  item-value="name"
                  menu-props="auto"
                  v-on:change="toWarehouseChangeEvent()"
                  :rules="[
                    () =>
                      !!stockTransfer.toWarehouseName ||
                      'To warehouse is required.',
                  ]"
                  :readonly="status != 'DRAFT' || isExistRequestNo"
                ></v-autocomplete>
                <h3
                  v-if="isError"
                  style="color: #ff5252; font: 12px Roboto, sans-serif"
                >
                  {{ error }}
                </h3>
              </v-flex>
              <v-flex sm6 v-else>
                <v-autocomplete
                  v-model="stockTransfer.toWarehouseName"
                  :items="activeWarehouseList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="To Warehouse"
                  item-text="name"
                  item-value="name"
                  menu-props="auto"
                  v-on:change="toWarehouseChangeEvent()"
                  :rules="[
                    () =>
                      !!stockTransfer.toWarehouseName ||
                      'To warehouse is required.',
                  ]"
                  :readonly="status != 'DRAFT' || isExistRequestNo"
                ></v-autocomplete>
                <h3
                  v-if="isError"
                  style="color: #ff5252; font: 12px Roboto, sans-serif"
                >
                  {{ error }}
                </h3>
              </v-flex>
              <v-flex sm6 v-if="toBinFlag">
                <v-autocomplete
                  v-model="stockTransfer.toBinId"
                  :items="toBinList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="To Bin"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :readonly="toBinDisable"
                  :rules="[
                    () => !!stockTransfer.toBinId || 'To Bin is required.',
                  ]"
                ></v-autocomplete>
              </v-flex>
              <v-flex>
                <v-layout>
                  <v-flex sm10>
                    <v-text-field
                      name="requestNo"
                      label="Request No"
                      v-model="stockTransfer.requestNo"
                      type="text"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm>
                    <v-btn
                      outline
                      color="warning"
                      :disabled="status != 'DRAFT' || !isRegister"
                      @click="showStockTransferRequest()"
                    >
                      <v-icon dark>search</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm6>
                <v-layout>
                  <v-flex sm10>
                    <v-text-field
                      name="stockTemplateName"
                      label="Stock Template Name"
                      v-model="stockTransfer.stockTemplateName"
                      type="text"
                      :readonly="status != 'DRAFT' || isExistRequestNo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm>
                    <v-btn
                      outline
                      color="warning"
                      :disabled="status != 'DRAFT' || isExistRequestNo"
                      @click="showStockTemplate"
                    >
                      <v-icon dark>search</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="typeList"
                  label="Stock Transfer Type"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  v-model="stockTransfer.type"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="stockTransfer.description"
                  type="text"
                  :rules="rules.descriptionRules"
                  :readonly="status != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="stockTransfer.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="stockTransfer.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="stockTransfer.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="stockTransfer.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="stockTransfer.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="stockTransfer.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="addStockTransferItem()"
                    :disabled="status != 'DRAFT' || isExistRequestNo"
                  >
                    Add Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                  <v-flex xs10 ml-4>
                    <v-text-field
                      name="scanBarcode"
                      label="Scan barcode....."
                      v-model="scanBarcode"
                      type="text"
                      v-on:keyup.enter="trigger(scanBarcode)"
                      prepend-icon="filter_center_focus"
                      :disabled="status != 'DRAFT' || isExistRequestNo"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row class="light--text">
                  <v-flex xs2>Code</v-flex>
                  <v-flex xs4>Name</v-flex>
                  <v-flex xs2>Unit</v-flex>
                  <v-flex xs2>Qty</v-flex>
                  <v-flex xs3>QC No</v-flex>
                  <v-flex xs2>Batch No</v-flex>
                  <v-flex xs3 class="text-xs-center">MFG Date</v-flex>
                  <v-flex xs3 class="text-xs-center">EXP Date</v-flex>
                  <v-flex xs2>Remark</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  v-for="(
                    stockTransferItem, index
                  ) in stockTransfer.stockTransferItems"
                  :key="index"
                >
                  <v-flex xs2>
                    <v-text-field
                      v-if="status == 'DRAFT' && !isExistRequestNo"
                      placeholder="Select the code"
                      v-model="stockTransferItem.productCode"
                      @click.stop="showProducts(), (selectedIndex = index)"
                      :rules="rules.codeRules"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      placeholder="Select the code"
                      v-model="stockTransferItem.productCode"
                      :rules="rules.codeRules"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      v-model="stockTransferItem.productName"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      placeholder="Name"
                      readonly
                      :rules="rules.productNameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-autocomplete
                      v-model="stockTransferItem.factorUnitName"
                      :items="stockTransferItem.productUnits"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      menu-props="auto"
                      placeholder="Select"
                      @change="(option) => changeFactorUnit(option, index)"
                      :rules="rules.unitRules"
                      :readonly="status != 'DRAFT' || isExistRequestNo"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="stockTransferItem.qty"
                      min="0"
                      :rules="rules.transferQtyRules"
                      :readonly="status != 'DRAFT'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-select
                      v-model="stockTransferItem.qcNo"
                      :items="stockTransferItem.stockQcNoDTOList"
                      item-text="qcNo"
                      item-value="qcNo"
                      color="blue-grey lighten-2"
                      menu-props="auto"
                      :readonly="status != 'DRAFT'"
                      :hide-no-data="true"
                      @change="getQcBatchNoList(stockTransferItem)"
                    ></v-select>
                  </v-flex>
                  <v-flex xs2>
                    <v-select
                      v-model="stockTransferItem.batchNo"
                      :items="stockTransferItem.batchNoList"
                      item-text="batchNo"
                      item-value="batchNo"
                      color="blue-grey lighten-2"
                      menu-props="auto"
                      :readonly="status != 'DRAFT'"
                      :hide-no-data="true"
                      @change="getBatchDate(stockTransferItem)"
                    ></v-select>
                  </v-flex>
                  <v-flex xs3>
                    <v-menu
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="status != 'DRAFT'"
                    >
                      <v-text-field
                        slot="activator"
                        placeholder="MFG Date"
                        type="text"
                        prepend-icon="event"
                        v-model="stockTransferItem.mfgDate"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="stockTransferItem.mfgDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs3>
                    <v-menu
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="status != 'DRAFT'"
                    >
                      <v-text-field
                        slot="activator"
                        placeholder="EXP Date"
                        type="text"
                        prepend-icon="event"
                        v-model="stockTransferItem.expDate"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="stockTransferItem.expDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      name="remark"
                      placeholder="Remark"
                      v-model="stockTransferItem.remark"
                      type="text"
                      :rules="rules.remarkRules"
                      :readonly="status != 'DRAFT'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      class="mx-0"
                      icon
                      @click="
                        removeStockTransferItem(index, stockTransferItem.id)
                      "
                      :disabled="status != 'DRAFT' || index == 0"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || status == 'FINISHED' || saveLoading"
                    @click="onSave"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="error" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setProduct(props.item.code, selectedIndex),
                        (showProductListDialog = !showProductListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">
                    {{ props.item.productGroup.name }}
                  </td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Stock Template list dialog-->
    <v-dialog
      v-model="showStockTemplateListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                v-model="stockTemplateQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="stockTemplateOnSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :must-sort="true"
                :headers="stockTemplateHeaders"
                :items="stockTemplateList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="stockTemplateTotalRows"
                :rows-per-page-items="stockTemplateRowsPerPageItems"
                :pagination.sync="stockTemplatePagination"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      prepareStockTransferItems(props.item),
                        (showStockTemplateListDialog =
                          !showStockTemplateListDialog)
                    "
                  >
                    <a>{{ props.item.name }}</a>
                  </td>
                  <td>{{ props.item.status }}</td>
                  <td>{{ props.item.description }}</td>
                  <td>
                    {{
                      props.item.updatedDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Stock Transfer Request list dialog-->
    <v-dialog
      v-model="showStockTransferRequestListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="stockTransferRequestQueryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="stockTransferRequestQueryParams.fromDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="stockTransferRequestQueryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="stockTransferRequestQueryParams.toDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="stockTransferRequestQueryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn
                outline
                color="primary"
                @click="stockTransferRequestOnSearch()"
              >
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :must-sort="true"
                :headers="stockTransferFromRequestHeaders"
                :items="stockTransferFromRequestList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="stockTransferRequestTotalRows"
                :rows-per-page-items="stockTransferRequestRowsPerPageItems"
                :pagination.sync="stockTransferFromRequestPagination"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    {{ props.item.issueDateInMilliSeconds | formatMsDate }}
                  </td>
                  <td
                    @click="
                      prepareStockTransferItemsByRequestNo(props.item),
                        (showStockTransferRequestListDialog =
                          !showStockTransferRequestListDialog)
                    "
                  >
                    <a>{{ props.item.issueNo }}</a>
                  </td>
                  <td>{{ props.item.status }}</td>
                  <td>{{ props.item.description }}</td>
                  <td>
                    {{
                      props.item.updatedDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { stockTransferService } from "../../services/stock-transfer-service";
import { warehouseService } from "../../services/warehouse-service";
import { StockTransfer, StockTemplateItem } from "../../models/model";
import { StockTransferItem } from "../../models/model";
import { commonService } from "../../services/common-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { StockTransferFormRules } from "../../helpers/validation-rules";
import { productService } from "../../services/product-service";
import { stockTemplateService } from "../../services/stock-template-service";
import { stockTransferRequestService } from "../../services/stock-transfer-request-service";
import { stockService } from "../../services/stock-service";

export default {
  name: "StockTransferDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Stock Transfer",
        disabled: false,
        to: "stock-transfers",
      },
      {
        text: "Stock Transfer Detail",
        disabled: true,
      },
    ],
    createdDate: "",
    updatedDate: "",
    warehouseId: "",
    fromWarehouseId: "",
    toWarehouseId: "",
    issueDate: "",
    fromWarehouseName: "",
    responseError: "",
    error: "",
    messageDialogBox: false,
    isError: false,
    stockTransfer: new StockTransfer(),
    oldStockTransfer: new StockTransfer(),
    stockTransferItem: new StockTransferItem(),
    saveLoading: false,
    statusList: [],
    adminStatusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "DELIVERY", value: "DELIVERY" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    activeWarehouseList: [],
    fromBinList: [],
    toBinList: [],
    toBinFlag: true,
    tempList: [],
    productList: [],
    status: "DRAFT",
    toBinDisable: false,
    isExistRequestNo: false,
    isRegister: false,
    rules: new StockTransferFormRules(),
    showProductListDialog: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      isPurchase: true,
    },
    search: null,
    code: "",
    showListLoading: false,
    selectedIndex: 0,
    stockTemplateList: [],
    stockTemplateTotalRows: 0,
    stockTemplateQueryParams: {
      name: "",
      status: "",
    },
    showStockTemplateListDialog: false,
    stockTemplateHeaders: [
      { text: "Name", value: "name" },
      { text: "Status", value: "status" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    stockTemplateRowsPerPageItems: [10, 50, 100],
    stockTemplatePagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    stockTransferRequestQueryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      fromWarehouseId: "",
    },
    stockTransferRequestTotalRows: 0,
    showStockTransferRequestListDialog: false,
    stockTransferRequestRowsPerPageItems: [25, 50, 100],
    stockTransferFromRequestPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    typeList: [
      { label: "GOOD", value: "GOOD" },
      { label: "DAMAGE", value: "DAMAGE" },
      { label: "PURCHASE_RETURN", value: "PURCHASE_RETURN" },
    ],
    stockTransferFromRequestList: [],
    stockTransferFromRequestHeaders: [
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Status", value: "status" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    scanBarcode: "",
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
    stockTemplatePagination: {
      handler() {
        this.getStockTemplateList();
      },
      deep: true,
    },
  },
  created() {
    if (
      this.user.roleName == "WAREHOUSE_MANAGER" ||
      this.user.roleName == "WAREHOUSE_STAFF" ||
      this.user.roleName == "BRANCH_ADMIN"
    ) {
      this.stockTransfer.fromWarehouseName = this.user.warehouseName;
      this.stockTransfer.fromWarehouseId = this.user.warehouseId;
      this.warehouseId = this.user.warehouseId;
      if (this.$route.params.id == "new") this.toBinFlag = false;
    }
    this.fromWarehouseName = this.user.warehouseName;
    this.getActiveWarehouses();
    this.stockTransfer.type = "GOOD";
    const id = this.$route.params.id;
    if (id == "new") {
      // new stockTransfer
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
      this.isRegister = true;
      this.addStockTransferItem();
    } else {
      this.getStockTransferDetail(id);
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },

    toWarehouseChangeEvent() {
      let warehouse = commonService.search(
        "name",
        this.stockTransfer.toWarehouseName,
        this.activeWarehouseList
      );
      if (warehouse) {
        this.toBinList = warehouse.binList;
      }
      if (
        this.stockTransfer.toWarehouseName ==
        this.stockTransfer.fromWarehouseName
      ) {
        this.isError = true;
        this.error = "To and From warehouse must be different.";
      } else {
        this.isError = false;
      }
    },

    fromWarehouseChangeEvent() {
      let warehouse = commonService.search(
        "name",
        this.stockTransfer.fromWarehouseName,
        this.activeWarehouseList
      );
      if (warehouse) {
        this.fromBinList = warehouse.binList;
      }
      if (
        this.stockTransfer.toWarehouseName ==
        this.stockTransfer.fromWarehouseName
      ) {
        this.isError = true;
        this.error = "To and From warehouse must be different.";
      } else {
        this.isError = false;
      }
    },

    // stock transfer request
    showStockTransferRequest() {
      // Clean query params
      this.stockTransfer.stockTemplateName = "";
      this.stockTransferRequestQueryParams.fromDate = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.stockTransferRequestQueryParams.toDate = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.stockTransferRequestQueryParams.issueNo = "";
      this.getStockTransferRequestList().then(
        (this.showStockTransferRequestListDialog =
          !this.showStockTransferRequestListDialog)
      );
    },
    stockTransferRequestOnSearch() {
      this.stockTransferRequestQueryParams.page =
        this.stockTransferFromRequestPagination.page;
      this.stockTransferRequestQueryParams.rowsPerPage =
        this.stockTransferFromRequestPagination.rowsPerPage;
      this.getStockTransferRequestList();
    },
    getStockTransferRequestList() {
      // Only 'CONFIRM' state stock transfer request can link with Stock Transfer
      this.stockTransferRequestQueryParams.status = "CONFIRM";
      this.stockTransferRequestQueryParams.toWarehouseId =
        this.user.warehouseId;
      this.showListLoading = true;
      let order = this.stockTransferFromRequestPagination.descending
        ? "desc"
        : "asc";
      return stockTransferRequestService
        .getStockTransferRequestList(
          this.stockTransferRequestQueryParams,
          this.stockTransferFromRequestPagination.page,
          this.stockTransferFromRequestPagination.rowsPerPage,
          this.stockTransferFromRequestPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockTransferFromRequestList =
              res.data.stockTransferRequestDTOList;
            this.stockTransferRequestTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    prepareStockTransferItemsByRequestNo(item) {
      this.stockTransfer.fromBinId = "";
      this.isExistRequestNo = true;
      this.stockTransfer.requestNo = item.issueNo;
      this.stockTransfer.fromWarehouseName = item.toWarehouseName;
      this.stockTransfer.fromWarehouseId = item.toWarehouseId;
      this.stockTransfer.toWarehouseName = item.fromWarehouseName;
      this.stockTransfer.toWarehouseId = item.fromWarehouseId;
      this.stockTransfer.stockTransferItems = [];
      let stockTransferItems = item.stockTransferRequestItems;
      if (stockTransferItems) {
        stockTransferItems.forEach((item) => {
          let stockTransferItem = {
            productId: "",
            productCode: "",
            productName: "",
            factorUnitName: "",
            productUnitId: "",
            productUnits: "",
            unitCost: 0,
            sellingPrice: 0,
            qty: 0,
            remark: "",
          };
          stockTransferItem.productId = item.productId;
          stockTransferItem.productCode = item.productCode;
          stockTransferItem.productName = item.productName;
          stockTransferItem.factorUnitName = item.factorUnitName;
          stockTransferItem.productUnitId = item.productUnitId;
          stockTransferItem.productUnits = item.productUnits;
          stockTransferItem.unitCost = item.unitCost;
          stockTransferItem.sellingPrice = item.sellingPrice;
          stockTransferItem.qty = item.qty;
          stockTransferItem.remark = item.remark;
          this.stockTransfer.stockTransferItems.push(stockTransferItem);
        });
      }
      this.fromWarehouseChangeEvent();
    },

    stockTemplateOnSearch() {
      this.stockTemplateQueryParams.page = this.stockTemplatePagination.page;
      this.stockTemplateQueryParams.rowsPerPage =
        this.stockTemplatePagination.rowsPerPage;
      this.getStockTemplateList();
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          // convert to millisecond
          this.stockTransfer.issueDateInMilliSeconds =
            commonService.convertToMilliseconds(this.issueDate);

          this.stockTransfer.stockTransferItems.forEach((stockTransferItem) => {
            if (stockTransferItem.mfgDate) {
              stockTransferItem.mfgDateInMilliSeconds =
                commonService.convertToMilliseconds(stockTransferItem.mfgDate);
            }
            if (stockTransferItem.expDate) {
              stockTransferItem.expDateInMilliSeconds =
                commonService.convertToMilliseconds(stockTransferItem.expDate);
            }
          });
          stockTransferService
            .saveStockTransfer(this.stockTransfer)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
                this.messageDialogBox = true;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    getStockTransferDetail(id) {
      stockTransferService
        .getStockTransferDetail(id)
        .then((res) => {
          this.stockTransfer = res.data;
          if (!this.stockTransfer.description)
            this.stockTransfer.description = "";
          if (this.stockTransfer.requestNo) {
            this.isExistRequestNo = true;
          }
          this.issueDate = commonService.formatDate(
            new Date(this.stockTransfer.issueDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.createdDate = commonService.formatDate(
            new Date(this.stockTransfer.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.stockTransfer.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );

          this.stockTransfer.stockTransferItems.forEach((stockTransferItem) => {
            if (stockTransferItem.mfgDateInMilliSeconds) {
              stockTransferItem.mfgDate = commonService.millisecondToDate(
                stockTransferItem.mfgDateInMilliSeconds,
                "YYYY-MM-DD"
              );
            }
            if (stockTransferItem.expDateInMilliSeconds) {
              stockTransferItem.expDate = commonService.millisecondToDate(
                stockTransferItem.expDateInMilliSeconds,
                "YYYY-MM-DD"
              );
            }
          });

          this.fromWarehouseId = res.data.fromWarehouseId;
          this.toWarehouseId = res.data.toWarehouseId;
          if (this.user.roleName == "WAREHOUSE_STAFF") {
            this.fromBinList = this.user.selectedBinList;
          } else {
            warehouseService
              .getWarehouseDetail(this.fromWarehouseId)
              .then((res) => {
                this.fromBinList = res.data.binList;
              });
          }
          warehouseService
            .getWarehouseDetail(this.toWarehouseId)
            .then((res) => {
              this.toBinList = res.data.binList;
            });
          if (
            this.toWarehouseId == this.warehouseId &&
            res.data.status == "DELIVERY"
          ) {
            this.toBinDisable = false;
          } else if (
            res.data.status != "DRAFT" ||
            this.user.role.roleName == "WAREHOUSE_MANAGER" ||
            this.user.role.roleName == "WAREHOUSE_STAFF" ||
            this.user.role.roleName == "BRANCH_ADMIN" ||
            this.isExistRequestNo
          ) {
            this.toBinDisable = true;
          }
          if (this.fromWarehouseId == this.warehouseId) {
            this.toBinFlag = false;
            this.statusList = [];
            if (res.data.status == "DRAFT") {
              this.statusList.push("DRAFT", "DELIVERY", "CANCEL");
            }
            if (res.data.status == "DELIVERY") {
              this.statusList.push("DELIVERY");
            }
            if (res.data.status == "CANCEL") {
              this.statusList.push("CANCEL");
            }
            if (res.data.status == "FINISHED") {
              this.statusList.push("FINISHED");
            }
          } else {
            this.statusList = [];
            if (res.data.status == "DRAFT") {
              this.statusList.push("DRAFT");
            }
            if (res.data.status == "DELIVERY") {
              this.statusList.push("DELIVERY", "FINISHED");
            }
            if (res.data.status == "FINISHED") {
              this.statusList.push("FINISHED");
            }
            this.toBinDisable = false;
          }

          this.issueDate = commonService.millisecondToDate(
            this.stockTransfer.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.status = this.stockTransfer.status;
          // deep copy
          this.oldStockTransfer = JSON.parse(JSON.stringify(res.data));
          //this.getWarehouseList();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getWarehouseList() {
      var fromWarehouse;
      var toWarehouse;
      var tempWarehouseList = [];
      fromWarehouse = this.stockTransfer.fromWarehouse.name;
      if (!this.tempList.includes(fromWarehouse)) {
        this.tempList.push(fromWarehouse);
        tempWarehouseList.push(this.stockTransfer.fromWarehouse);
      }
      toWarehouse = this.stockTransfer.toWarehouse.name;
      if (!this.tempList.includes(toWarehouse)) {
        this.tempList.push(toWarehouse);
        tempWarehouseList.push(this.stockTransfer.toWarehouse);
      }
      for (var j = 0; j < this.activeWarehouseList.length; j++) {
        var temp = this.activeWarehouseList[j].name;
        if (!this.tempList.includes(temp)) {
          this.tempList.push(temp);
          tempWarehouseList.push(this.activeWarehouseList[j]);
        }
      }
      this.activeWarehouseList = tempWarehouseList;
    },

    getActiveWarehouses() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.activeWarehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        })
        .finally(() => {
          if (this.fromWarehouseName) {
            if (this.user.roleName == "WAREHOUSE_STAFF") {
              this.fromBinList = this.user.selectedBinList;
            } else {
              let warehouse = commonService.search(
                "name",
                this.fromWarehouseName,
                this.activeWarehouseList
              );
              this.fromBinList = warehouse.binList;
            }
          }
        });
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getStockTemplateList() {
      this.showListLoading = true;
      this.stockTemplateQueryParams.status = "ACTIVE";
      let order = this.stockTemplatePagination.descending ? "desc" : "asc";
      return stockTemplateService
        .getStockTemplateList(
          this.stockTemplateQueryParams,
          this.stockTemplatePagination.page,
          this.stockTemplatePagination.rowsPerPage,
          this.stockTemplatePagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockTemplateList = res.data.stockTemplateList;
            this.stockTemplateTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    showProducts() {
      if (
        this.stockTransfer.fromWarehouseName &&
        this.stockTransfer.fromBinId
      ) {
        // Clean query params
        this.queryParams.code = "";
        this.queryParams.name = "";
        this.queryParams.brandName = "";
        this.queryParams.categoryName = "";
        this.queryParams.productGroupName = "";

        this.getProductList().then(
          (this.showProductListDialog = !this.showProductListDialog)
        );
      } else {
        this.messageDialogBox = true;
        if (!this.stockTransfer.fromWarehouseName) {
          this.responseError = "Please select from warehouse first.";
        } else if (!this.stockTransfer.fromBinId) {
          this.responseError = "Please select from bin first.";
        }
      }
    },
    showStockTemplate() {
      // Clean query params
      this.stockTemplateQueryParams.name = "";
      this.stockTemplateQueryParams.status = "";

      this.getStockTemplateList().then(
        (this.showStockTemplateListDialog = !this.showStockTemplateListDialog)
      );
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.stockTransfer.id) {
        this.stockTransfer = new StockTransfer();
        this.stockTransfer.fromWarehouseName = this.user.warehouseName;
        this.stockTransfer.fromWarehouseId = this.user.warehouseId;
        this.addStockTransferItem();
        this.isExistRequestNo = false;
      } else {
        this.stockTransfer = Object.assign({}, this.oldStockTransfer);
        this.stockTransfer.fromWarehouseName =
          this.oldStockTransfer.fromWarehouseName;
        this.stockTransfer.fromWarehouseId =
          this.oldStockTransfer.fromWarehouseId;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    addStockTransferItem() {
      // deep copy
      let sti = JSON.parse(JSON.stringify(this.stockTransferItem));

      this.stockTransfer.stockTransferItems.push(sti);
    },
    removeStockTransferItem(index, stockTransferItemId) {
      if (stockTransferItemId) {
        // add delete stockTransfer item id
        if (!this.stockTransfer.deleteStockTransferItemIds) {
          this.stockTransfer.deleteStockTransferItemIds = [];
        }
        this.stockTransfer.deleteStockTransferItemIds.push(stockTransferItemId);
      }
      this.$delete(this.stockTransfer.stockTransferItems, index);
    },
    setProduct(code, index) {
      let product = commonService.search("code", code, this.productList);
      this.stockTransfer.stockTransferItems[index].productId = product.id;
      this.stockTransfer.stockTransferItems[index].productCode = product.code;
      this.stockTransfer.stockTransferItems[index].productName = product.name;
      // set default unit
      var j = "";
      for (var i = 0; i < product.productUnits.length; i++) {
        if (product.productUnits[i].basicUnit == true) j = i;
      }
      this.stockTransfer.stockTransferItems[index].productUnitId =
        product.productUnits[j].id;
      this.stockTransfer.stockTransferItems[index].factorUnitName =
        product.productUnits[j].factorUnitName;
      this.stockTransfer.stockTransferItems[index].productUnits =
        product.productUnits;
      this.getProductQcBatchDateList(
        this.stockTransfer.stockTransferItems[index]
      );
      this.stockTransfer.stockTransferItems[index].qty = 0;
      this.stockTransfer.stockTransferItems[index].remark = "";
      this.clearQCno(this.stockTransfer.stockTransferItems[index]);
    },
    getProductQcBatchDateList(stockTransferItem) {
      stockTransferItem.qcNo = "";
      stockTransferItem.batchNo = "";
      stockTransferItem.mfgDate = "";
      stockTransferItem.expDate = "";
      let params = {
        warehouseId: this.stockTransfer.fromWarehouseId,
        binId: this.stockTransfer.fromBinId,
        productId: stockTransferItem.productId,
        balanceType: "WITH_BALANCE",
      };
      return stockService
        .getStockQcBatchDateList(params)
        .then((res) => {
          stockTransferItem.stockQcNoDTOList = res.data;
          this.getQcBatchNoList(stockTransferItem);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getQcBatchNoList(stockTransferItem) {
      stockTransferItem.batchNo = "";
      stockTransferItem.mfgDate = "";
      stockTransferItem.expDate = "";
      let qc = stockTransferItem.stockQcNoDTOList.find(
        (v) => v.qcNo == stockTransferItem.qcNo
      );
      if (qc) {
        stockTransferItem.batchNoList = qc.batchNoList;
        this.getBatchDate(stockTransferItem);
      }
    },
    getBatchDate(stockTransferItem) {
      stockTransferItem.mfgDate = "";
      stockTransferItem.expDate = "";
      let batchNo = stockTransferItem.batchNoList.find(
        (v) => v.batchNo == stockTransferItem.batchNo
      );
      if (batchNo) {
        let batchDate = batchNo.qcBatchDateDTOList.find(
          (v) => v.batchNo == stockTransferItem.batchNo
        );
        if (batchDate) {
          stockTransferItem.mfgDate = batchDate.mfgDate;
          stockTransferItem.expDate = batchDate.expDate;
        }
      }
    },
    changeFromWarehouse() {
      this.stockTransfer.fromBinId = "";
      let fromWarehouse = this.activeWarehouseList.find(
        (v) => v.name == this.stockTransfer.fromWarehouseName
      );
      if (fromWarehouse) {
        this.stockTransfer.fromWarehouseId = fromWarehouse.id;
      }
      if (this.stockTransfer.id) {
        this.stockTransfer.stockTransferItems.forEach((item) => {
          if (!this.stockTransfer.deleteStockTransferItemIds) {
            this.stockTransfer.deleteStockTransferItemIds = [];
          }
          this.stockTransfer.deleteStockTransferItemIds.push(item.id);
        });
      }
      this.stockTransfer.stockTransferItems = [];
      this.addStockTransferItem();
      this.fromWarehouseChangeEvent();
    },
    changeFromBin() {
      if (this.stockTransfer.id) {
        this.stockTransfer.stockTransferItems.forEach((item) => {
          if (!this.stockTransfer.deleteStockTransferItemIds) {
            this.stockTransfer.deleteStockTransferItemIds = [];
          }
          this.stockTransfer.deleteStockTransferItemIds.push(item.id);
        });
      }
      this.stockTransfer.stockTransferItems = [];
      this.addStockTransferItem();
    },
    prepareStockTransferItems(item) {
      var stockTransfer = this.stockTransfer;
      stockTransfer.stockTemplateName = item.name;
      // Clear previous datas
      stockTransfer.stockTransferItems = [];

      let stockTemplateItems = item.stockTemplateItems;
      if (stockTemplateItems) {
        stockTemplateItems.forEach((item) => {
          let stockTemplateItem = JSON.parse(
            JSON.stringify(new StockTemplateItem())
          );
          stockTemplateItem.productId = item.productId;
          stockTemplateItem.productCode = item.productCode;
          stockTemplateItem.productName = item.productName;
          stockTemplateItem.factorUnitName = item.factorUnitName;
          stockTemplateItem.productUnitId = item.productUnitId;
          stockTemplateItem.productUnits = item.productUnits;
          stockTemplateItem.qty = item.qty;
          // Push stock template item to stock transfer items
          stockTransfer.stockTransferItems.push(stockTemplateItem);
        });
      }
    },
    trigger(barcode) {
      if (barcode) {
        this.getProductUnitByBarcode(barcode);
      }
    },
    getProductUnitByBarcode(bcode) {
      let params = {
        barcode: bcode,
      };
      productService
        .getProductUnitByBarcode(params)
        .then((res) => {
          let productUnit = res.data;
          if (productUnit) {
            this.setProductByBarcode(productUnit);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.scanBarcode = "";
        });
    },

    setProductByBarcode(productUnit) {
      if (this.stockTransfer.stockTransferItems[0].productCode == "") {
        this.addValuesToFirstStockTransferItem(productUnit);
      } else if (this.isItemExist(productUnit)) {
        this.addQtyToExistingStockTransferItem(productUnit);
      } else {
        this.addNewItemToStockTransferItemList(productUnit);
      }
    },
    addQtyToExistingStockTransferItem(productUnit) {
      this.stockTransfer.stockTransferItems.forEach((item) => {
        if (item.productUnitId === productUnit.id) {
          item.qty = Math.abs(item.qty) + 1;
        }
      });
    },
    isItemExist(productUnit) {
      for (let item of this.stockTransfer.stockTransferItems) {
        if (item.productUnitId === productUnit.id) {
          return true;
        }
      }
    },
    addValuesToFirstStockTransferItem(productUnit) {
      this.stockTransfer.stockTransferItems[0].productId =
        productUnit.product.id;
      this.stockTransfer.stockTransferItems[0].productCode =
        productUnit.product.code;
      this.stockTransfer.stockTransferItems[0].productName =
        productUnit.product.name;
      this.stockTransfer.stockTransferItems[0].productUnitId = productUnit.id;
      this.stockTransfer.stockTransferItems[0].productUnits.push(productUnit);
      this.stockTransfer.stockTransferItems[0].factorUnitName =
        productUnit.factorUnitName;
      this.stockTransfer.stockTransferItems[0].qty = 1;
    },
    addNewItemToStockTransferItemList(productUnit) {
      let stockTransferItem = JSON.parse(
        JSON.stringify(this.stockTransferItem)
      );
      stockTransferItem.productId = productUnit.product.id;
      stockTransferItem.productCode = productUnit.product.code;
      stockTransferItem.productName = productUnit.product.name;
      stockTransferItem.productUnitId = productUnit.id;
      stockTransferItem.productUnits[0] = productUnit;
      stockTransferItem.factorUnitName = productUnit.factorUnitName;
      stockTransferItem.qty = 1;

      this.stockTransfer.stockTransferItems.push(stockTransferItem);
    },
    changeFactorUnit(factorUnitName, index) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.stockTransfer.stockTransferItems[index].productUnits
      );
      if (this.checkItemDuplicate(productUnit, index)) {
        let item = productUnit.product.name + " (" + factorUnitName + ")";
        this.responseError = "Stock Transfer Item: " + item + " is duplicated";
        this.messageDialogBox = true;
      }
      this.stockTransfer.stockTransferItems[index].productUnitId =
        productUnit.id;
    },
    checkItemDuplicate(productUnit, index) {
      for (let item in this.stockTransfer.stockTransferItems) {
        if (item != index) {
          if (
            this.stockTransfer.stockTransferItems[item].productUnitId ===
            productUnit.id
          ) {
            return true;
          }
        }
      }
    },
    clearQCno(stockTransferItem) {
      stockTransferItem.qcNo = "";
      stockTransferItem.batchNo = "";
      stockTransferItem.mfgDate = "";
      stockTransferItem.mfgDateInMilliSeconds = "";
      stockTransferItem.expDate = "";
      stockTransferItem.expDateInMilliSeconds = "";
    },
  },
};
</script>

